// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"b90120cf","93":"b74249d2","115":"97cce078","121":"890d6b2b","129":"65afb1c8","416":"5f8a1891","467":"c0b04d80","496":"ce8038f2","533":"f15e0846","630":"4e305438","901":"c090fd6c","991":"0b8cba33"}[chunkId] + ".chunk.js";
};